import React from 'react';
import PropTypes from 'prop-types';
import Documents from './Documents';

const DocumentsRow = ({ id, binder, case_uuid, court_code, case_number, claimNum, seqNum }) => {
  if (binder && binder.documents && binder.documents.length > 0) {
    return (
      <tr key={`documents-row-${id}`} className="docket docket_details dockets-documents-row no-filter-search">
        <td colSpan="2" />
        <td className="here" colSpan="100%">
          <table className="sticky-enabled">
            <thead>
              <tr key={`details-desc-${id}`} className="no-filter-search">
                <th />
                <th>Part</th>
                <th>Description</th>
                <th>Pages</th>
                <th width="40%">Action</th>
              </tr>
            </thead>
            <tbody>
              <Documents
                documents={binder.documents}
                case_uuid={case_uuid}
                court_code={court_code}
                case_number={case_number}
                claimNum={claimNum}
                seqNum={seqNum}
                docket_seq={`${claimNum}-${seqNum}`}
              />
            </tbody>
          </table>
        </td>
      </tr>
    );
  }

  return (
    <tr key={`documents-row-${id}`} className="docket_details no-filter-search ">
      <td colSpan="2" />
      <td className="here" colSpan="100%">
        No Accessible Documents Found
      </td>
    </tr>
  );
};

DocumentsRow.propTypes = {
  id: PropTypes.string.isRequired,
  binder: PropTypes.object.isRequired,
  case_uuid: PropTypes.string.isRequired,
  court_code: PropTypes.string.isRequired,
  case_number: PropTypes.string.isRequired,
  claimNum: PropTypes.number.isRequired,
  seqNum: PropTypes.string.isRequired,
};

export default DocumentsRow;



// WEBPACK FOOTER //
// ./src/components/case/claims/claimsEntries/DocumentsRow.jsx